export const PAGES = {
  HOME: 'home',
  MENU: 'menu',
  SHOP: 'shop',
  ABOUT: 'about',
  GALLERY: 'gallery',
  CATERING: 'catering',
  CHURCH_PARTNERSHIP: 'church-partnership',
  INITIATIVES: 'initiatives',
  CALENDAR: 'calendar',
  CONTACT: 'contact',
  CART: 'cart',
  ACCOUNT: 'account'
} as const;

export type PageType = typeof PAGES[keyof typeof PAGES];

export const ICONS = {
  logoMark: '/assets/logos/koinoniacp_logomark-black.svg',
  primary: '/assets/logos/koinoniacp_primary-black.svg',
  secondary: '/assets/logos/koinoniacp_secondary-black.svg',
  instagramIcon: '/assets/icons/icons8-instagram-96.png',
  emailIcon: '/assets/icons/icons8-mail-50.svg',
  heroImage: 'https://firebasestorage.googleapis.com/v0/b/koinonia-coffee-project.firebasestorage.app/o/products%2FDSCF3464.jpg?alt=media&token=c31db4d4-a0b4-41ac-ba33-81f729615366',
  shopPlaceholder: '/assets/images/shop_placeholder.png',
  v60: '/assets/icons/v60.png',
  chemex: '/assets/icons/chemex.png',
  espresso: '/assets/icons/espresso.png'
} as const;

export const ASSETS = {

} as const;

export const FONTS = {
  primary: 'HedvigLettersSerif_18pt',
  slug: 'ShipporiAntiqueB1',
  secondary: 'Besley-Italic',
  body: 'RethinkSans-Regular'
} as const;

export const COLORS = {
  midnightPrimary: '#2F2B39',
  linenPrimary: '#CBC5B9',
  marinaPrimary: '#313D66',
  pearlPrimary: '#F8F5EB',
  denimSecondary: '#59667E',
  smokeSecondary: '#C2CAD3',
  eucalyptusSecondary: '#84825E',
  sageSecondary: '#C3C8A4',
  white: '#FFFFFF'
} as const;

export const LAYOUT = {
  notificationBarHeight: 40,
  appBarHeight: 80,
  bottomBarHeight: 140,
  mobileBreakpoint: 768,
  desktopBreakpoint: 1024
} as const;

export const isMobile = (width: number): boolean => width < LAYOUT.mobileBreakpoint;
export const isDesktop = (width: number): boolean => width >= LAYOUT.desktopBreakpoint;
